// noinspection JSValidateTypes

import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import ReactDOMServer from 'react-dom/server'
import PropTypes from 'prop-types'
import {
    FullscreenControl,
    GeolocationControl,
    Map,
    Placemark,
    RouteButton,
    RulerControl,
    SearchControl,
    TrafficControl,
    TypeSelector,
    YMaps,
    ZoomControl
} from '@pbe/react-yandex-maps'
import * as orderApi from '@api/order'
import * as siteHelpers from '@helpers/site'
import * as S from './SelectorStock.styled'
import * as Theme from '@styles/theme-const'
import StockItemDescription from './StockItemDesciption/StockItemDesciption'
import Input from '../shared/Input/Input'
import Cross from '../Icons/Cross'
import Button from '@shared/Button/Button'
import BalloonMap from './BalloonMap/BalloonMap'
import { useChangeStock, useShipment } from '@entities/shipment/model'
import { useStocks } from '@entities/stocks/model'
import { useCities } from '@entities/cities/hooks'
import { useGoodIds } from 'src/features/shipment-selector/hooks'
import { minBy } from 'lodash-es'

const SelectorStock = (props) => {
    const changeStock = useChangeStock()
    const stocks = useStocks()
    const cities = useCities()
    const shipment = useShipment()
    const goodIds = useGoodIds()
    const [selectedStock, setSelectedStock] = useState({
        id: 0,
        title: ''
    })
    // noinspection SpellCheckingInspection
    const [ymaps, setYmaps] = useState(null)
    const [cityId, setCityId] = useState(1)
    const FilterTypes = {
        All: 1,
        Today: 2,
        Other: 3
    }
    const [activeFilters, setActiveFilters] = useState({
        searchText: '',
        filterType: FilterTypes.All
    })
    const [stocksGoods, setStocksGoods] = useState([])
    const [filters, setFilters] = useState([])

    const changeSearchTextHandler = (e) => {
        setActiveFilters({
            ...activeFilters,
            searchText: e.target.value
        })
    }
    const changeLocalSelectedStock = (id) => {
        const stock = stocksGoods.find((x) => x.id === id)
        if (stock) {
            if (stock.isOpened) {
                setSelectedStock({
                    id: stock.id,
                    title: `${stock.title} ${stock.address}`
                })
            } else {
                setSelectedStock({
                    id: 0,
                    title: ''
                })
            }
        }
    }

    const [mapState, setMapState] = useState({
        center: [55.751574, 37.573856],
        zoom: 9
    })

    const setCenterHandler = (coords, zoom) => {
        setMapState({
            ...mapState,
            center: coords,
            zoom
        })
    }

    const clickPlacemarkHandler = (id) => () => {
        const stock = stocksGoods.find((st) => st.id === id)
        changeLocalSelectedStock(id, stock.isOpened)
        setMapState({
            ...mapState,
            center: [stock.coordinateX, stock.coordinateY],
            zoom: 16
        })
    }

    const selectedStockHandler = (id, coords, isOpened) => {
        changeLocalSelectedStock(id, coords, isOpened)
        setCenterHandler(coords, 16)
    }
    const getLayout = (Component, cusProps) => {
        if (ymaps && ymaps.templateLayoutFactory) {
            // eslint-disable-next-line react/jsx-props-no-spreading
            const html = ReactDOMServer.renderToString(<Component {...cusProps} />)
            const Layout = ymaps.templateLayoutFactory.createClass(`<div id="balloon">${html}</div>`, {
                build() {
                    // noinspection JSUnresolvedReference
                    Layout.superclass.build.call(this)
                    // eslint-disable-next-line react/jsx-props-no-spreading,react/no-deprecated
                    ReactDOM.hydrate(<Component {...cusProps} />, document.getElementById('balloon'))
                }
            })

            return Layout
        }
        return null
    }

    const initFilteredStocks = async (cityId) => {
        const newStocksGoods = await orderApi.getStocksGoods(cityId, goodIds)
        const stocksGoodsTr = stocks
            .filter((x) => x.cityId === cityId)
            .map((x) => {
                const stockWithGoods = newStocksGoods?.find((ns) => ns.id === x.id) || null
                if (stockWithGoods) {
                    return {
                        ...x,
                        ...stockWithGoods
                    }
                }
                return x
            })

        setStocksGoods(stocksGoodsTr)
        const stocksCount = stocksGoodsTr.length

        const demandsStocks = stocksGoodsTr.filter((x) => x.count === goodIds.length)
        const stockWithMinDate = minBy(demandsStocks, (x) => x.maxAptEtaDateTime)

        let arrayFilters
        if (!props.fromGood)
            arrayFilters = [
                {
                    count: stocksCount,
                    title: 'Все аптеки',
                    type: FilterTypes.All
                },
                {
                    count: stocksGoodsTr.filter((x) => x.count === goodIds.length && x.isNotDemandInStock).length,
                    title: 'Выдача сегодня',
                    type: FilterTypes.Today
                }
            ]
        else
            arrayFilters = [
                {
                    count: stocksGoodsTr.filter(
                        (x) => x.count === goodIds.length && x.count > 0 && x.isNotDemandInStock
                    ).length,
                    title: 'Выдача сегодня',
                    type: FilterTypes.Today
                }
            ]
        // noinspection JSUnresolvedReference
        if (stockWithMinDate?.maxAptEtaDateTime) {
            // noinspection JSUnresolvedReference
            arrayFilters.push({
                count: demandsStocks.length,
                title: `Выдача ${stockWithMinDate && siteHelpers.convertDate(stockWithMinDate.maxAptEtaDateTime)}`,
                type: FilterTypes.Other
            })
        }
        switchFilterHandler(arrayFilters[0].type)()
        setFilters(arrayFilters)
    }

    useEffect(() => {
        changeLocalSelectedStock(shipment.stockId || 0)
        setCityId(shipment.cityId)
        const city = cities.find((c) => c.id === shipment.cityId)
        setCenterHandler([city.coordinateX, city.coordinateY], city.mapZoom)
        // noinspection JSIgnoredPromiseFromCall
        initFilteredStocks(shipment.cityId)
        // eslint-disable-next-line
    }, [stocks.length])

    const changeSelectedCityHandler = (id) => () => {
        const city = cities.find((c) => c.id === id)
        setCityId(id)
        // noinspection JSIgnoredPromiseFromCall
        initFilteredStocks(id)
        setCenterHandler([city.coordinateX, city.coordinateY], city.mapZoom)
    }

    const switchFilterHandler = (type) => () => {
        setActiveFilters({
            ...activeFilters,
            filterType: type
        })
    }

    const changeStockHandler = () => {
        //props.changeSelectedStockHandler(selectedStock.id, cityId)
        // noinspection JSCheckFunctionSignatures
        changeStock({ cityId: cityId, stockId: selectedStock.id, stockTitle: selectedStock.title })
    }

    const changeStockWithIdHandler = (id) => {
        const stock = stocksGoods.find((x) => x.id === id)
        //props.changeSelectedStockHandler(stock.id, cityId)
        // noinspection JSCheckFunctionSignatures
        changeStock({ cityId: cityId, stockId: stock.id, stockTitle: stock.title })
    }

    const getFilteredStocks = () => {
        // eslint-disable-next-line no-unreachable
        let stocksFiltered = stocksGoods.filter((stock) => stock.cityId === cityId)

        if (activeFilters.searchText) {
            stocksFiltered = stocksFiltered.filter((stock) =>
                `${stock.name} ${stock.city} ${stock.address}`
                    .toLowerCase()
                    .includes(activeFilters.searchText.toLowerCase())
            )
        }

        if (activeFilters.filterType === FilterTypes.Today) {
            stocksFiltered = stocksFiltered.filter(
                (stock) => stock.count === goodIds.length && stock.isNotDemandInStock
            )
        }

        if (activeFilters.filterType === FilterTypes.Other) {
            stocksFiltered = stocksFiltered.filter((stock) => stock.count === goodIds.length)
        }

        return stocksFiltered
    }
    const noOpenUrl = `${process.env.NEXT_PUBLIC_BASE_PATH || ''}/images/map_logo_notopened.png`
    return (
        <S.AbsoluteContainer>
            <S.Window>
                <S.Header>
                    <S.HeaderBlock>
                        {props.fromGood ? (
                            <S.HeaderTitle>Аптеки в которых есть выбранный товар</S.HeaderTitle>
                        ) : (
                            <S.HeaderTitle>Выберите Аптеку</S.HeaderTitle>
                        )}
                        <S.ButtonSubmitContainer>
                            {selectedStock.id ? (
                                <Button
                                    data-submit-button
                                    elementSizeTypeValue={Theme.ElementSizeType.regular}
                                    clickHandler={changeStockHandler}>
                                    Подтвердить
                                </Button>
                            ) : (
                                <React.Fragment />
                            )}
                        </S.ButtonSubmitContainer>
                    </S.HeaderBlock>
                    <S.ButtonClose onClick={props.closeHandler}>
                        <Cross />
                    </S.ButtonClose>
                </S.Header>
                <S.Body>
                    <S.StockSelectedTitle>{selectedStock.title}</S.StockSelectedTitle>
                    <S.Container>
                        <S.StockComboboxSearch>
                            <S.FilterBlock>
                                <Input
                                    data-search-input
                                    data-search-type="stock"
                                    value={activeFilters.searchText}
                                    placeholder="Адрес аптеки, Метро, Город, ТЦ"
                                    onChange={changeSearchTextHandler}
                                />
                                <S.SwitchFilterButtons>
                                    {filters
                                        .filter((x) => x.count > 0)
                                        .map((filter) => (
                                            <S.FilterButton
                                                key={filter.type}
                                                isActive={filter.type === activeFilters.filterType}
                                                onClick={switchFilterHandler(filter.type)}>
                                                <S.FilerButtonText>{filter.title}</S.FilerButtonText>{' '}
                                                <S.CountIndicate>{filter.count}</S.CountIndicate>
                                            </S.FilterButton>
                                        ))}
                                </S.SwitchFilterButtons>
                            </S.FilterBlock>

                            <S.StocksBlock>
                                {getFilteredStocks().map((x) => (
                                    <StockItemDescription
                                        key={x.id}
                                        id={x.id}
                                        fromGood={props.fromGood}
                                        isMetroLocation={x.isMetroLocation}
                                        goodsCount={{
                                            count: x.count,
                                            goodOrders: x.goodOrders,
                                            isNotDemandInStock: x.isNotDemandInStock,
                                            maxAptEtaDateTime: x.maxAptEtaDateTime,
                                            maxCount: x.maxCount,
                                            id: x.id
                                        }}
                                        changeStockWithIdHandler={changeStockWithIdHandler}
                                        isOpened={x.isOpened}
                                        maxCount={goodIds.length}
                                        name={x.name}
                                        title={x.title}
                                        tradingCenterTitle={x.tradingCenterTitle}
                                        city={x.city}
                                        address={x.address}
                                        metroColor={x.metroColor}
                                        coords={[x.coordinateX, x.coordinateY]}
                                        time={{
                                            from: x.optTimeFrom,
                                            to: x.optTimeTo
                                        }}
                                        timeString={x.timeString}
                                        clickHandler={selectedStockHandler}
                                    />
                                ))}
                            </S.StocksBlock>
                        </S.StockComboboxSearch>

                        <S.MapBlock>
                            <S.SwitchFilterButtons>
                                {cities.map((city) => (
                                    <S.FilterButton
                                        key={city.id}
                                        onClick={changeSelectedCityHandler(city.id)}
                                        isActive={city.id === cityId}>
                                        {city.title}
                                    </S.FilterButton>
                                ))}
                            </S.SwitchFilterButtons>
                            <YMaps>
                                <Map
                                    modules={[
                                        'geolocation',
                                        'geocode',
                                        'templateLayoutFactory',
                                        'geoObject.addon.balloon',
                                        'geoObject.addon.hint'
                                    ]}
                                    onLoad={(ymaps) => setYmaps(ymaps)}
                                    width="100%"
                                    height="100%"
                                    state={{
                                        center: mapState.center,
                                        zoom: mapState.zoom
                                    }}>
                                    <FullscreenControl />
                                    <GeolocationControl options={{ float: 'left' }} />
                                    <RouteButton options={{ float: 'right' }} />
                                    <RulerControl options={{ float: 'right' }} />
                                    <TypeSelector options={{ float: 'right' }} />
                                    <TrafficControl options={{ float: 'right' }} />
                                    <SearchControl options={{ float: 'left' }} />
                                    <ZoomControl options={{ float: 'right' }} />
                                    {getFilteredStocks().map((stock) => (
                                        <Placemark
                                            key={stock.id}
                                            onClick={clickPlacemarkHandler(stock.id)}
                                            options={{
                                                iconLayout: 'default#image',
                                                iconImageHref: stock.isOpened
                                                    ? `${process.env.NEXT_PUBLIC_BASE_PATH || ''}/images/map_logo.png`
                                                    : noOpenUrl,
                                                iconImageSize: [25, 23],
                                                iconImageOffset: [-13, -14],
                                                balloonCloseButton: true,
                                                hideIconOnBalloonOpen: false,
                                                hintContent: stock.title,
                                                balloonContentLayout: getLayout(BalloonMap, {
                                                    stock,
                                                    changeStockHandler: () => changeStockWithIdHandler(stock.id)
                                                })
                                            }}
                                            geometry={[stock.coordinateX, stock.coordinateY]}
                                        />
                                    ))}
                                </Map>
                            </YMaps>
                        </S.MapBlock>
                    </S.Container>
                </S.Body>
            </S.Window>
        </S.AbsoluteContainer>
    )
}

SelectorStock.propTypes = {
    closeHandler: PropTypes.func.isRequired,
    fromGood: PropTypes.bool
}

export default SelectorStock
